export default function CrM() {
  return (
    <div className="cr-m">
      <small>
        Made with <span className="text-danger">❤</span> by Rizall Kadamong
      </small>
    </div>
  );
}
